<template>
  <div>
    <b-form @submit.prevent="handleSaveTax" class="pb-3" v-if="!fetching">
      <b-row class="manager-tax-setting">
        <b-col sm="12" lg="12" style="padding: 0" class="tax-setting">
          <b-card class="mb-4 tax-setting-card">
            <b-card-body class="tax-setting-form-card-body p-0">
              <div class="container tax-setting-container">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <span style="font-weight: semi-bold; font-size: 20pt">Tax Settings</span>
                  </div>
                </div>
                <hr class="mt-1" />

                <!-- Show content only when data is loaded and not fetching -->
                <div class="col-md-12 tax-setting-form">
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label="Enable Tax">
                        <b-form-checkbox v-model="taxSettings.enabled"></b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Tax fields - only show when tax is enabled -->
                  <div class="col-md-12 tax-form mt-4">
                    <b-form-group>
                      <b-row class="mb-1">
                        <div class="col-md-3 px-0">
                          <label class="form-title d-inline-block w-100 pt-2">
                            Tax Name
                            <span class="required">*</span>
                          </label>
                        </div>
                        <div class="col-md-9 pl-0">
                          <b-form-input v-model="taxSettings.tax_name" placeholder="Enter tax name..."></b-form-input>
                        </div>
                      </b-row>
                    </b-form-group>

                    <b-form-group>
                      <b-row class="mb-1">
                        <div class="col-md-3 px-0">
                          <label class="form-title d-inline-block w-100 pt-2">
                            Tax Registration Number
                            <span class="required">*</span>
                          </label>
                        </div>
                        <div class="col-md-9 pl-0">
                          <b-form-input
                            v-model="taxSettings.tax_registration_number"
                            placeholder="Enter tax registration number..."
                          ></b-form-input>
                        </div>
                      </b-row>
                    </b-form-group>

                    <b-form-group>
                      <b-row class="mb-1">
                        <div class="col-md-3 px-0">
                          <label class="form-title d-inline-block w-100 pt-2">
                            Tax Rate (%)
                            <span class="required">*</span>
                          </label>
                        </div>
                        <div class="col-md-9 pl-0">
                          <b-form-input
                            v-model="taxSettings.tax_rate"
                            type="number"
                            step="0.01"
                            placeholder="Enter tax rate..."
                            @input="calculateTaxAmount"
                          ></b-form-input>
                        </div>
                      </b-row>
                    </b-form-group>

                    <b-row>
                      <b-col sm="12" class="text-center mt-4 mb-3">
                        <b-button type="submit" variant="primary">
                          {{ __('Save') }}
                        </b-button>
                      </b-col>
                    </b-row>

                    <b-alert :variant="success ? 'success' : 'danger'" v-if="message" show>
                      {{ message }}
                    </b-alert>

                    <div v-for="(errs, field) in errors" :key="field">
                      <b-alert v-for="err in errs" :key="err" variant="danger" show>
                        {{ err }}
                      </b-alert>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fetching: false,
      success: false,
      errors: {},
      message: '',
      taxSettings: {
        enabled: false,
        tax_name: '',
        tax_registration_number: '',
        tax_rate: '',
      },
    };
  },

  async mounted() {
    this.taxSettings = await this.fetchTaxSettings();
  },

  methods: {
    async fetchTaxSettings() {
      try {
        let {
          data: {
            data: {
              settings: { enabled, value },
            },
          },
        } = await axios.get('/api/tax_settings');
        return { enabled, ...value };
      } catch (error) {
        this.showErrorNotification(this, error.response.data.errors, __(error.response.data.message));
      } finally {
        this.processing = false;
      }
    },

    async handleSaveTax() {
      this.success = false;
      this.message = '';
      this.errors = {};

      let postData = { ...this.taxSettings, _method: 'put' };

      try {
        let {
          data: { message, success },
        } = await axios.post('/api/tax_settings', postData);
        this.success = success;
        this.message = message;
      } catch (error) {
        this.success = false;
        this.message = error.response.data.message;
        this.errors = error.response.data.errors;
      } finally {
      }
    },
  },
};
</script>

<style>
.action-btn {
  padding: 5px 10px;
}

.spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 360px) {
  .tax-setting-card-body,
  .tax-setting-container {
    padding: 0;
  }

  .tax-setting-card {
    width: 285px;
  }

  .tax-setting-form {
    padding: 0;
  }

  .layout-sidebar-large .main-content-wrap {
    padding-right: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .manager-tax-setting {
    width: 113% !important;
  }
}
</style>
